<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="classifyName" >
        <span slot="label" >
          <a-tooltip>
            {{$t('动态分类名称')}}<template slot="title">{{$t('动态分类名称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.classifyName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('动态分类名称')" />
      </a-form-model-item>

      <!--多语言集成-->
      <a-form-item v-if="form.localeList.length > 0" :label="this.$t('通用.文本.多语言配置')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" class="margin-bottom-10">
        <a-table :data-source="form.localeList" :columns="localeColumns" rowKey="id" :pagination="false" bordered>
          <span slot="locale" slot-scope="text, record">
           <custom-dict-tag :options="customDict.LocaleEnum" :value="record.locale"/>
          </span>
          <div slot="name" slot-scope="text, record" >
            <a-input v-model="record.name" :maxLength="16" :placeholder="$t('通用.输入.请输入')+$t('动态分类名称')"  @blur.native.capture="validatorLocaleName"  />
          </div>
          <div slot="action" slot-scope="text, record">
            <a-button type="primary" @click="getTranslation(record)">
              {{$t('通用.按钮.翻译')}}
            </a-button>
          </div>
        </a-table>
        <span style="color: red;">{{ errorMessage }}</span>
      </a-form-item>
      <!--多语言集成-->

      <a-form-model-item :label="this.$t('公告背景图')" prop="picture">
        <OssUploadSingle v-model="form.picture" type="img" prefix="live" :maxSize="20" />
        <span>推荐尺寸 351:100</span>
      </a-form-model-item>

      <a-form-model-item :label="this.$t('公告标题')" prop="announcementTitle">
        <a-input v-model="form.announcementTitle" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('公告标题')" />
      </a-form-model-item>

      <a-form-model-item :label="this.$t('公告描述')" prop="announcementDesc">
        <a-textarea v-model="form.announcementDesc" :rows="4" :maxLength="90" showCount :placeholder="$t('通用.输入.请输入')+$t('公告描述')" />
        <div style="margin-top: 4px; color: #999; font-size: 12px;">{{ $t('建议90字以内') }}</div>
      </a-form-model-item>

      <a-form-model-item :label="this.$t('论坛样式类型')" prop="forumStyle">
        <a-select v-model="form.forumStyle" :placeholder="$t('通用.输入.请选择')+$t('论坛样式类型')">
          <a-select-option v-for="(item, index) in customDict.ForumStyleEnum" :key="index" :value="item.type">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>






      <a-form-model-item prop="sort" >
        <span slot="label" >
          <a-tooltip>
            {{$t('动态分类排序')}}<template slot="title">{{$t('动态分类排序')}}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.sort"   />
      </a-form-model-item>

      <a-form-model-item prop="status" >
        <span slot="label" >
          <a-tooltip>
            {{$t('是否有效')}}<template slot="title">{{$t('是否有效')}}</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button v-for="(d, index) in statusOptions" :key="index" :value="d.value">{{ d.label }}</a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getRecommendCategory, addRecommendCategory, updateRecommendCategory } from '@/api/video/recommendCategory'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import OssUploadSingle from "@/components/OssUploadSingle";
//多语言集成
import {translation} from "@/api/tool/common";
//多语言集成

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    OssUploadSingle,
  },
  data () {
    return {
      statusOptions:[
        {label:"是",value:1},
        {label:"否",value:0}
      ],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        classifyName: null,

        picture: null,

        announcementTitle: null,

        announcementDesc: null,

        forumStyle: 1,

        sort: null,

        status: 0,

        createTime: null,

        remark: null,
        // 多语言集成
        localeList: [],
        // 多语言集成
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          classifyName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
          forumStyle: [{ required: true, message: '请选择论坛样式类型', trigger: 'change' }],
      },
      //多语言集成
      errorMessage:undefined,
      localeColumns: [
        {
          title: this.$t('通用.文本.语言'),
          dataIndex: 'locale',
          key: 'locale',
          scopedSlots: { customRender: 'locale' }
        }, {
          title: this.$t('主营行业.分类名称'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
          key: 'name'
        }, {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'action',
          key: 'action',
          slots: { title: 'addbtn', customRender: 'brandName' },
          scopedSlots: { customRender: 'action' }
        }
      ],
      //多语言集成
    }
  },
  filters: {
  },
  created () {
  },
  //多语言集成
  computed: {
    ...mapGetters(['customDict'])
  },
//多语言集成
  watch: {
  },
  mounted () {
  },
  methods: {


    // oss 上传开始
    // oss 上传结束






    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        classifyName: null,
        picture: null,
        announcementTitle: null,
        announcementDesc: null,
        forumStyle: 1,
        sort: null,
        status: 0,
        createTime: null,
        remark: null,
        //多语言集成
        localeList:[]
        //多语言集成
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加');
      //多语言集成
      this.initLocale();
      //多语言集成
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRecommendCategory({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateRecommendCategory(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addRecommendCategory(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    //多语言集成
    initLocale() {
      //获取全局配置的语言
      const sysLangList = globalThis.$openLangList;
      //初始化多语言
      let localeList = [];
      let i = 1;
      this.customDict.LocaleEnum.forEach(e => {
        if(sysLangList.includes(e.type)){
        localeList.push({"id": i, "locale": e.type, 'name': ''})
        i++;
      }
    })
      this.form.localeList = localeList;
    },

    validatorLocaleName() {
      let errorMessage = "";
      var localeList = this.form.localeList;
      let localeEnum = this.customDict.LocaleEnum;
      localeList.forEach(e=>{
        if (!e.name) {
        let localeName = localeEnum.find(locale=>locale.type===e.locale).name;
        errorMessage += localeName + this.$t('通用.文本.不能为空')+';';
      }
    })
      if (errorMessage) {
        this.errorMessage = errorMessage;
        return false;
      }
      this.errorMessage = "";
      return true;
    },
    getTranslation(record) {
      if (!this.form.classifyName) {
        return
      }
      let data = {"text": this.form.classifyName, "locale": record.locale};
      translation(data).then(response => {
        record.name = response.data
    });

    },
    limitSort(record) {
      // console.log(i);
      let val=record.sort.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1');
      if(val==null||val==undefined||val==''){
        val=0
      }
      if (val > 21474836) {
        val = 21474836
      }
      record.sort = val
    },
    //多语言集成
  }
}
</script>
